<template>
  <div class="global-table">
    <table class="table">
      <thead>
        <tr>
          <th v-for="(h, i) in dataStruct.thead" :key="i">
            {{ h }}
          </th>
        </tr>
      </thead>
      <tbody :key="offset">
        <tr v-for="(data, i) in pagesData[offset]" :key="i">
          <td :class="b.name" v-for="(b, i) in dataStruct.tbody" :key="i"
              v-html="data[b.name]"
              @click="checkEvent(b.emitClickEvent) ? emitEvent(b, data) : ''"
          ></td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="1000">
            <div>
              <paginator
                :offset="offset"
                :total="total"
                :limit="limit"
                :pages="pages"
                @change-page="changePage"
              />
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: "global-table",
  props: {
    data: {
      type: [Array, Object],
      required: true,
      default: [],
    },
    limit: {
      type: [Number],
      default: 50
    },
    dataStruct: {
      type: [Array, Object],
      required: true,
      default: function () {
        return {
          thead: ["#", "title"],
          tbody: ["id","title"]
        }
      }
    },
  },
  data() {
    return {
      offset: 0,
      total: this.data.length,
      pagesTotal: this.pages,
      pagesData: this.separar(this.data, this.limit)
    }
  },
  methods: {
    changePage(value) {
      this.offset = value;
    },
    separar(base, max) {
      var res = [];

      for (var i = 0; i < base.length; i = i+(max-1)) {
        res.push(base.slice(i,(i+max)));
      }
      res[res.length-1].push(base[0]);
      return res;
    },
    checkEvent: (val) => {
      return val === undefined || val === false ? false : true;
    },
    emitEvent(e, data) {
      console.log('data -> ', e)
      this.$emit(`${e.eventName}`, data);
    }
  },
  computed: {
    pages() {
      const qty = Math.ceil(this.total / this.limit);
      if (qty <= 1) return [1];
      return Array.from(Array(qty).keys(), (i) => i + 1);
    }
  }
}
</script>

<style scoped lang="scss">
.global-table {
  width: 100%;
  height: auto;
  .table {
    thead, tbody > tr {
      height: 6rem;
    }
    thead {
      background: #F3F3F3;
      tr {
        th {
          text-transform: capitalize;
          border: 0 !important;
          color: #006FE6;
          font-weight: 900;
        }
      }
    }
    thead > tr > th, tbody > tr > th, tbody > tr > td{
      font-family: 'Lato';
      font-size: 14px;
      vertical-align: middle;
    }
    thead > tr > th:first-child,
    tbody > tr > td:first-child {
      padding-left: 3rem;
    }
    th, td, code {
      word-wrap: break-word;
      max-width: 40rem;
      width: auto;
    }
    tbody {
      tr:first-child {
        th, td {
          border-top: 0 !important;
        }
      }
      tr {
        th, td {
          border-top: 1px solid #DADADA;
          font-weight: 400 !important;
          color: #444444;
        }
      }
    }
    tfoot {
      border-top: 1px solid #DADADA;
      height: 3rem;
      background-color: #F5F5F5;
      td {
        text-align: center;
      }
      td > div {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;
      }
    }
  }
}
.key {
  cursor: pointer !important;
  color: #4D98FF !important;
  text-shadow: 1px 1px 3px #b4b4b4;
  :hover {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// resources/global/js/components/global-table/GlobalTable.vue